import { computed, markRaw } from 'vue'

import { DropdownActionsData } from '@types'

import { useModalsStore } from '@/store/modals'
import { useUserStore } from '@/store/user'

import ModalsSettings from '@/modules/modals/Settings/Settings.vue'
import { LogOutIcon, Settings2Icon } from '@lucide/vue'

export const useUser = () => {

  const modalsStore = useModalsStore()
  const userStore = useUserStore()
  
  const email = computed(() => userStore.getEmail)
  
  const name = computed(() => {
    return email.value?.split('@')[0]
      .split('.')
      .map(name => name.charAt(0).toUpperCase() + name.slice(1)).join(' ')
  })
  
  const initials = computed(() => {
    const nameParts = name.value?.split(' ') || []
    const parts = nameParts.length > 1 ? nameParts.slice(0, 2) : nameParts[0]?.split('') || []
    return parts.slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('') || ''
  })

  const menuItems = computed<DropdownActionsData[]>(() => [
    {
      label: 'Settings',
      icon: Settings2Icon,
      action: (hide: () => void) => {
        hide()
        const modalInstance = modalsStore.init('settings', markRaw(ModalsSettings))
        modalInstance?.open(modalsStore.getZIndex(), {})
      },
    },
    {
      label: 'Sign out',
      icon: LogOutIcon,
      action: () => {
        userStore.signOut()
      },
    },
  ])

  return {
    email,
    name,
    initials,
    menuItems
  }
}
